import _ from 'underscore';

import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { IdentityPoolService } from '~src/authentication/services/IdentityPoolService';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { IListWithTokenFetcher } from '~src/httpClient/fetchers/IListWithTokenFetcher';
import { ListResultWithToken } from '~src/httpClient/fetchers/ListResultWithToken';
import { WebClientListWithTokenResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListWithTokenResourceFetcher';
import { ResourceQueryWithPagingToken } from '~src/httpClient/resources/ResourceQueryWithPagingToken';
import { IPagedItemsWithTokenParams } from '~src/httpClient/serverApi/types/IPageWithToken';
import { SiteAuthenticationSettingsService } from '~src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { ISiteUserInfo } from '~src/userManagement/users/models/ISiteUserInfo';
import { GetSiteUsersWithTokenRequest } from '~src/userManagement/users/serverApi/requests/GetSiteUsersWithTokenRequest';


function fetchList(params: IPagedItemsWithTokenParams): Promise<ListResultWithToken<ISiteUserInfo>> {
  let listFetcher: IListWithTokenFetcher<ISiteUserInfo> = new WebClientListWithTokenResourceFetcher(GetSiteUsersWithTokenRequest, ServerApiMapper.siteUsersWithToken);
  const promises: Promise<any>[] = [];

  promises.push(listFetcher.fetchList(params));

  if (SiteAuthenticationSettingsService.isEnabled()) {
    promises.push(SiteAuthenticationSettingsService.getAuthSettingToProviderIdMap());
  }

  if (FeatureFlags.identityPoolsEnabled) {
    promises.push(IdentityPoolService.tryFetchActiveIdentityPools());
  }

  return Promise.all(promises)
  .then((results: any[]) => {
    const userList: ListResultWithToken<ISiteUserInfo> = results.shift();

    if (SiteAuthenticationSettingsService.isEnabled()) {
      const map: _.Dictionary<string> = results.shift();
      _.each(userList.items, (siteUser: ISiteUserInfo) => {
        siteUser.authenticationProviderId = map[siteUser.authSetting];
      });
    }

    if (FeatureFlags.identityPoolsEnabled) {
      const pools: IIdentityPool[] = results.shift();
      _.each(userList.items, (siteUser: ISiteUserInfo) => {
        siteUser.poolMemberships = [];

        _.each(siteUser.systemUserIdentities, (record: string[]) => {
          const poolId = record[0];
          const identityId = record[1];
          const identityPool = poolId ? pools.find(x => x.id === poolId) : IdentityPoolService.defaultIdentityPool();
          if (identityPool) {
            siteUser.poolMemberships.push({
              identityPool: identityPool,
              identityUuid: identityId
            });
          }
        });
      });
    }

    return userList;
  });
}

export const AuthenticationProviderIdFetcherForGetSiteUsersToken = {fetchList};

class SiteUsersWithToken extends ResourceQueryWithPagingToken<ISiteUserInfo> {
  public static readonly instance = new SiteUsersWithToken(AuthenticationProviderIdFetcherForGetSiteUsersToken);
}

export const SiteUsersWithTokenResource = SiteUsersWithToken.instance;
